import { Component } from "preact";
import style from "./style";
import { formatTotalAmount, getCurrencySymbol } from "../../../utils/utility";

export default class Button extends Component {
  render({ buttonText, type, disabled, showLoader, buttonAmount }) {
    type = type || "text";
    return (
      <button type={type} className={`${style["submit-btn"]} ${style["btn-primary"]} ib`} disabled={disabled}>
        <span className={`${showLoader ? style["hide-btn-text"] : ""} ${style["btn-text"]}`}>
          {buttonText}{" "}
          {!!buttonAmount && (
            <span>
              <span id="rupee" className={`${style["rupee-sign"]}`}>
                {getCurrencySymbol()}
              </span>
              {formatTotalAmount(buttonAmount)}
            </span>
          )}
        </span>
        {showLoader && (
          <div className={`${style.spinner} ${style.proceedSpinner}`}>
            <div className={`${style.bounce1}`} />
            <div className={`${style.bounce2}`} />
            <div className={`${style.bounce3}`} />
            <div className={`${style.bounce4}`} />
            <div className={`${style.bounce5}`} />
          </div>
        )}
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./form/components/button/index.js